// src/lib/supabaseClient.ts
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const rawUrl  = (process.env.REACT_APP_SUPABASE_URL ?? "").trim();
const rawAnon = (process.env.REACT_APP_SUPABASE_ANON_KEY ?? "").trim();

if (!/^https?:\/\/.+\.supabase\.co/.test(rawUrl)) {
  console.error("REACT_APP_SUPABASE_URL is invalid:", rawUrl);
  throw new Error("Invalid REACT_APP_SUPABASE_URL");
}
if (!rawAnon) {
  console.error("REACT_APP_SUPABASE_ANON_KEY is missing/empty");
  throw new Error("Missing REACT_APP_SUPABASE_ANON_KEY");
}

export const supabase: SupabaseClient = createClient(rawUrl, rawAnon, {
  db: { schema: "public" },                         // ← add this line
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

// (optional) dev-only debug
if (typeof window !== "undefined") {
  // @ts-ignore
  console.log("[supabase] restUrl:", (supabase as any).restUrl, "authUrl:", (supabase as any).authUrl);
  (window as any).supabase = supabase;
  (window as any)._API_ = process.env.REACT_APP_API;
}
